/**
 * @generated SignedSource<<6d5f820f549f26468b87248e36947a38>>
 * @relayHash 4556cb0833994933eb707e5eb735de76
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4556cb0833994933eb707e5eb735de76

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type De_sendBetterDocReferralSlipInput = {
  endDate: any;
  sessionId: number;
  startDate: any;
};
export type useSendBetterDocReferralSlipMutation$variables = {
  input: De_sendBetterDocReferralSlipInput;
};
export type useSendBetterDocReferralSlipMutation$data = {
  readonly de_sendBetterDocReferralSlip: {
    readonly actionResult: {
      readonly betterDocState: de_BetterDocRecommendationState | null;
      readonly caseId: string | null;
      readonly errorReason: string | null;
      readonly exchangeId: number | null;
      readonly httpStatusCode: number | null;
      readonly isSuccessful: boolean;
      readonly sessionId: number;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useSendBetterDocReferralSlipMutation = {
  response: useSendBetterDocReferralSlipMutation$data;
  variables: useSendBetterDocReferralSlipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "actionResult",
  "args": null,
  "concreteType": "de_BetterDocSessionActionResult",
  "kind": "LinkedField",
  "name": "de_BetterDocSessionActionResult",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccessful",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "httpStatusCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "betterDocState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exchangeId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendBetterDocReferralSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_sendBetterDocReferralSlipPayload",
        "kind": "LinkedField",
        "name": "de_sendBetterDocReferralSlip",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSendBetterDocReferralSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_sendBetterDocReferralSlipPayload",
        "kind": "LinkedField",
        "name": "de_sendBetterDocReferralSlip",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4556cb0833994933eb707e5eb735de76",
    "metadata": {},
    "name": "useSendBetterDocReferralSlipMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c97b2839718231fac762469cf0053ac0";

export default node;
